module.exports = __webpack_public_path__ + "img/alentour27.918211c3.jpg";